import { useQuery } from '@tanstack/react-query';
import { TEmailTemplate } from 'components/FlowBuilder/FlowSidePanels/types';
import emailService from 'services/api/email.api';

const useEmailTemplates = () => {
  const { data, isLoading, error } = useQuery<TEmailTemplate[], Error>({
    queryKey: ['email-templates'],
    queryFn: () => emailService.getEmailTemplates(),
    refetchOnWindowFocus: false,
  });

  return {
    emailTemplates: data || [],
    areEmailTemplatesLoading: isLoading,
    emailTemplatesError: error,
  };
};

export default useEmailTemplates;
